import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  add_syllabus,
  delete_syllabus,
  get_syllabus,
  update_syllabus,
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  syllabus: [],
  class_id: "",
  subject_id: "",
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    subject: "",
    file: "",
    school_class:""
  },
};


// Async Thunks for API Calls
export const fetchsyllabus = createAsyncThunk(
  "syllabus/fetchsyllabus",
  async (
    { page, page_size, school_id,subject_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_syllabus(
        page,
        page_size,
        school_id,
        subject_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createsyllabus = createAsyncThunk(
  "syllabus/createsyllabus",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_syllabus(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatesyllabus = createAsyncThunk(
  "syllabus/updatesyllabus",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_syllabus(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletesyllabus = createAsyncThunk(
  "syllabus/deletesyllabus",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_syllabus({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const syllabusSlice = createSlice({
  name: "syllabus",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id,subject, file } = action.payload;
      state.formData = { id,subject, file };
    },
    resetFormData(state) {
      state.formData = {
        subject: "",
        file: "",
        school_class:""
      };
    },
    setSyllabus(state, action) {
      state.syllabus = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
    setClassId(state, action) {
      state.class_id = action.payload;
    },
    setSubjectId(state, action) {
        state.subject_id = action.payload;
      },
  },
  extraReducers: (builder) => {
    builder
   
      // Fetch Classes
      .addCase(fetchsyllabus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchsyllabus.fulfilled, (state, action) => {
        state.loading = false;
        state.syllabus = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchsyllabus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createsyllabus.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createsyllabus.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createsyllabus.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatesyllabus.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatesyllabus.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatesyllabus.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;
        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletesyllabus.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletesyllabus.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletesyllabus.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setSyllabus,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  setClassId,
  setSubjectId
} = syllabusSlice.actions;
export default syllabusSlice.reducer;
